import React from "react";
import { Container, Row, Col, Card, Carousel } from "react-bootstrap";
import CustomNavbar from "./Navbar";
import "./2DModeling.css";

// 2D Drawing Data
const civilDrawings = [
  {
    title: "Civil & Structural GA Drawings",
    images: [
      "/2ddetail/ga/7.png",
      "/2ddetail/ga/8.png",
      "/2ddetail/ga/9.png",
    ],
    description:
      "General arrangement drawings showing comprehensive layout of civil and structural elements",
  },
  {
    title: "Structural Fabrication Drawings",
    images: [
      "/2ddetail/Structural/1.png",
      "/2ddetail/Structural/2.png",
      "/2ddetail/Structural/3.png",
    ],
    description:
      "Detailed fabrication drawings with material specifications and connection details",
  },
  {
    title: "Chute Fabrication Drawings",
    images: [
      "/2ddetail/chute/1.PNG",
      "/2ddetail/chute/2.PNG",
      "/2ddetail/chute/3.png",
    ],
    description:
      "Specialized drawings for chute systems including wear patterns and material specifications",
  },
];

// const pipingDrawings = [
//   {
//     title: "Piping GA Layouts",
//     images: [
//       "/drawings/piping-ga/1.jpg",
//       "/drawings/piping-ga/2.jpg",
//       "/drawings/piping-ga/3.jpg",
//     ],
//     description:
//       "Overall piping system layouts with equipment locations and routing",
//   },
//   {
//     title: "Piping Isometric Drawings",
//     images: [
//       "/drawings/isometric/1.jpg",
//       "/drawings/isometric/2.jpg",
//       "/drawings/isometric/3.jpg",
//     ],
//     description:
//       "3D representation of piping systems with detailed measurements and annotations",
//   },
//   {
//     title: "Spool Drawings",
//     images: [
//       "/drawings/spool/1.jpg",
//       "/drawings/spool/2.jpg",
//       "/drawings/spool/3.jpg",
//     ],
//     description:
//       "Fabrication-level drawings for individual pipe spools with BOM",
//   },
// ];

// Quantity Survey Data with Images
const quantitySurveyData = [
  {
    title: "Bar Bending Schedule (BBS)",
    image: "/2ddetail/bbs/BBS.PNG",
    description:
      "Detailed reinforcement schedules with bending shapes and cutting lengths",
    highlights: [
      "Material specifications",
      "Shape codes and dimensions",
      "Weight calculations",
    ],
  },
  {
    title: "Structural Quantity Take-offs",
    image: "/2ddetail/survey/image.png",
    description:
      "Comprehensive material quantification for structural elements",
    highlights: ["Concrete volumes", "Reinforcement weights", "Formwork areas"],
  },
  {
    title: "Cable Scheduling",
    image: "/2ddetail/cable/image003.png",
    description: "Detailed cable routing and specification documentation",
    highlights: [
      "Cable types and lengths",
      "Routing paths",
      "Termination details",
    ],
  },
];

const DrawingCarousel = ({ title, images, description }) => (
  <Card className="drawing-card h-100">
    <Carousel
      variant="dark"
      interval={3000}
      controls={true}
      indicators={true}
      pause="hover"
    >
      {images.map((img, idx) => (
        <Carousel.Item key={idx}>
          <img
            src={img}
            alt={`${title} ${idx + 1}`}
            className="d-block w-100"
          />
        </Carousel.Item>
      ))}
    </Carousel>
    <Card.Body>
      <Card.Title>{title}</Card.Title>
      <Card.Text>{description}</Card.Text>
    </Card.Body>
  </Card>
);

const QuantityCard = ({ title, image, description, highlights }) => (
  <Card className="quantity-card h-100">
    <div className="quantity-image-container">
      <img src={image} alt={title} className="quantity-image" />
    </div>
    <Card.Body>
      <Card.Title>{title}</Card.Title>
      <Card.Text>{description}</Card.Text>
      <ul className="highlight-list">
        {highlights.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </Card.Body>
    <Card.Footer className="bg-white border-0">
      {/* <button className="btn btn-primary btn-sm">View Full Document</button> */}
    </Card.Footer>
  </Card>
);

const TwoDModeling = () => {
  return (
    <>
      <CustomNavbar />
      <Container className="py-5 detailed-design-container">
        {/* Hero Section */}
        <section className="design-hero text-center mb-5">
          <h1 className="display-5 fw-bold mb-3">
            <span className="highlight">2D Detailed Design</span> Drawings
          </h1>
          <p className="lead text-muted">
            Precision engineering drawings for construction and fabrication
          </p>
        </section>

        {/* Civil & Structural Section */}
        <section className="drawing-section mb-5">
          <h2 className="section-title mb-4">
            <span>Civil & Structural Drawings</span>
          </h2>
          <Row xs={1} md={2} lg={3} className="g-4">
            {civilDrawings.map((drawing, index) => (
              <Col key={index}>
                <DrawingCarousel {...drawing} />
              </Col>
            ))}
          </Row>
        </section>

        {/* Piping Section */}
        {/* <section className="drawing-section mb-5">
          <h2 className="section-title mb-4">
            <span>Piping System Drawings</span>
          </h2>
          <Row xs={1} md={2} lg={3} className="g-4">
            {pipingDrawings.map((drawing, index) => (
              <Col key={index}>
                <DrawingCarousel {...drawing} />
              </Col>
            ))}
          </Row>
        </section> */}

        {/* Electrical Section */}
        <section className="drawing-section mb-5">
          <h2 className="section-title mb-4">
            <span>Electrical Drawings</span>
          </h2>
          <Row xs={1} md={2} lg={3} className="g-4">
            <Col>
              <DrawingCarousel
                title="Electrical Layouts"
                images={[
                  "/2ddetail/lighting/ga/1.jpg",
                  "/2ddetail/lighting/ga/2.jpg",
                  "/2ddetail/lighting/ga/3.jpg",
                  
                ]}
                description="Comprehensive electrical system layouts and wiring diagrams"
              />
            </Col>
            <Col>
              <DrawingCarousel
                title="Lighting Plans"
                images={[
                  "/2ddetail/lighting/plans/1.jpg",
                  "/2ddetail/lighting/plans/2.jpg",
                  "/2ddetail/lighting/plans/3.jpg",
                ]}
                description="Detailed lighting design and fixture placement plans"
              />
            </Col>
            <Col>
              <DrawingCarousel
                title="Electrical Panel"
                images={[
                  "/2ddetail/lighting/panel/panel1.jpeg",
                  "/2ddetail/lighting/panel/panel2.jpg",
                ]}
                description="Panel schedules and circuit diagrams for efficient power distribution"
              />
            </Col>
          </Row>
        </section>

        {/* Quantity Survey Section */}
        <section className="quantity-section mb-5">
          <h2 className="section-title mb-4">
            <span>Quantity Survey Documentation</span>
          </h2>
          <p className="section-description mb-5">
            Detailed material quantification and scheduling for accurate cost
            estimation and procurement
          </p>

          <Row xs={1} md={2} lg={3} className="g-4">
            {quantitySurveyData.map((item, index) => (
              <Col key={index}>
                <QuantityCard {...item} />
              </Col>
            ))}
          </Row>
        </section>

        {/* CTA Section */}
        <section className="design-cta text-center py-5 mt-5">
          <h2 className="mb-3">Our Expertise</h2>

          <p className="mb-4">
            We specialize in delivering high-precision 2D detailed design
            drawings and comprehensive quantity surveying solutions. Our
            expertise spans across civil and structural GA drawings, fabrication
            detailing, piping layouts, and accurate material quantification
            including BBS and cable scheduling.
          </p>
        </section>
      </Container>
    </>
  );
};

export default TwoDModeling;
